import React from 'react';
import { Icon } from '@groupby/ui-components';
import { StyledSortIconsContainer } from './sort-icons.styles';
export const SortIcons = ({ className }) => (<StyledSortIconsContainer className={className}>
    <Icon variant="chevronUp" className="sort-icon-asc"/>
    <Icon variant="chevronDown" className="sort-icon-desc"/>
  </StyledSortIconsContainer>);
export default SortIcons;
